import { useState } from 'react'
import { useParams } from '@tanstack/react-router'
import { CheckCircle, XCircle } from 'lucide-react'
import { PublicExpenseEditForm } from '../components/PublicExpenseEditForm'
import { usePublicExpenseQuery } from '../hooks/expenses/usePublicExpenseQuery'
import Loader from '@/components/Loader'
import { usePublicChurchesQuery } from '@/features/churches/hooks/usePublicChurchesQuery'

export function PublicExpenseEditPage() {
  const { token } = useParams({ from: '/fix-expense/$token' })
  const [isSubmitted, setIsSubmitted] = useState(false)

  const { data, isLoading, error } = usePublicExpenseQuery(token, !!token)

  const { data: churches, isLoading: churchesLoading } =
    usePublicChurchesQuery()

  if (isLoading || churchesLoading) return <Loader />

  if (error || !data) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="text-center">
          <XCircle className="h-16 w-16 text-red-500 mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-red-600 mb-2">
            Invalid or Expired Link
          </h2>
          <p className="text-gray-600">
            This correction link is no longer valid. Please contact the
            administrator.
          </p>
        </div>
      </div>
    )
  }

  if (isSubmitted) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="text-center py-8">
          <CheckCircle className="h-16 w-16 text-green-500 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Request Resubmitted!
          </h2>
          <p className="text-gray-600">
            Your reimbursement request has been updated and resubmitted for
            review.
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-4xl border border-gray-300 rounded-lg p-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">
            Update Expense Request
          </h1>
          <p className="text-sm text-gray-500 mt-1">
            Reference: {data.expense.refNumber}
          </p>
        </div>
        <PublicExpenseEditForm
          token={token}
          expense={data.expense}
          categories={data.categories}
          churches={churches ?? []}
          onSuccess={() => setIsSubmitted(true)}
        />
      </div>
    </div>
  )
}
